import { useEffect } from "react";
import { Box, Text, VStack, Button } from "@chakra-ui/react";
import { FaWhatsapp } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { useBalanceSolicitation } from "@/contexts/balanceSolicitationContext";
import { statusInfoMap } from "@/utils/balanceSolicitationStatusMapper";
import { keyframes } from "@emotion/react";
import Logo from "@/components/Logo";
import { useSlug } from "@/contexts/selfServiceSlugContext";

export default function UserStatus() {
  const { selfServiceSlug } = useSlug();
  const { shorthash } = useParams<{ shorthash: string }>();
  const { balanceSolicitation } = useBalanceSolicitation();
  const whatsappNumber = selfServiceSlug?.supportPhone;

  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      if (balanceSolicitation?.status !== "PENDING") {
        if (
          balanceSolicitation?.status === "SUCCESS" ||
          balanceSolicitation?.status === "PENDING_CONFIRMATION"
        ) {
          clearInterval(interval);
          navigate(`/${shorthash}/proposal/${balanceSolicitation?.id}`);
        } else {
          clearInterval(interval);
          navigate(`/${shorthash}/introducao`);
        }
      }
    }, 8000);

    return () => clearInterval(interval);
  }, [balanceSolicitation, balanceSolicitation?.id, shorthash, navigate]);

  const handleSupport = () => {
    let phoneNumber = "+55" + whatsappNumber?.replace(/\D/g, "");

    const message =
      "Olá, estou tentando antecipar meu saque aniversário e tenho uma dúvida!";
    const whatsappURL = `https://wa.me/${phoneNumber}/?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappURL, "_blank");
  };

  const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      bg="gray.100"
      color="black"
      minH="100vh"
      textAlign="center"
      p={4}
    >
      <Button
        position={"absolute"}
        onClick={handleSupport}
        top={6}
        right={6}
        size="sm"
        variant="outline"
        leftIcon={<FaWhatsapp size={16} />}
        color="primary"
        bg="white"
        _hover={{ bg: "white", color: "primary" }}
      >
        Suporte
      </Button>

      <Box
        w={"95%"}
        borderRadius={"25px"}
        bg="white"
        height={"70vh"}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        color="secondary"
      >
        <Text fontSize="2xl" fontWeight="bold" mb={6}>
          Consultando na CEF
        </Text>

        <Box w="80px" h="auto" mb={6} animation={`${pulse} 1.5s infinite`}>
          <Logo
            variant="primary"
            alt="Logo"
            style={{ width: "100%", height: "auto" }}
          />
        </Box>

        <VStack spacing={2} mb={8} align="center">
          <Text fontWeight="bold">
            {balanceSolicitation?.status
              ? statusInfoMap[balanceSolicitation?.status]?.label
              : "Erro inesperado."}
          </Text>
          <Text fontSize="sm">
            {balanceSolicitation?.status
              ? statusInfoMap[balanceSolicitation?.status]?.tagLabel
              : "Tente novamente em 5 minutos."}
          </Text>
          <Text fontWeight="bold">Você será redirecionado.</Text>
        </VStack>
      </Box>
    </Box>
  );
}
